function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M58.9666 49.5L92.96 4L172.52 65.5957L176.576 131.298L33.7757 155.936L28.6195 107.5H46.5V134.5H79.5V107.5H106V75H79.5V49.5H58.9666ZM46.5 66.1865L39.9154 75H46.5V66.1865ZM35.84 177.152L178.64 151.83L180 170.993L37.88 197L35.84 177.152Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.5 49.5C32.5 41.768 38.768 35.5 46.5 35.5H79.5C87.232 35.5 93.5 41.768 93.5 49.5V61H106C113.732 61 120 67.268 120 75V107.5C120 115.232 113.732 121.5 106 121.5H93.5V134.5C93.5 142.232 87.232 148.5 79.5 148.5H46.5C38.768 148.5 32.5 142.232 32.5 134.5V121.5H21C13.268 121.5 7 115.232 7 107.5V75C7 67.268 13.268 61 21 61H32.5V49.5ZM46.5 49.5H79.5V75H106V107.5H79.5V134.5H46.5V107.5H21V75H46.5V49.5Z",
  fill: "currentColor"
});

function SvgAcceleration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceleration);
export default __webpack_public_path__ + "static/media/acceleration.84e009c1.svg";
export { ForwardRef as ReactComponent };